import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function ConfirmationModal({ show, onHide, onConfirm, title, message }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header closeButton className="bg-danger text-white">
                <Modal.Title>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-warning">
                    <h5>{message}</h5>
                    <p>This action cannot be undone.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="secondary" 
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button 
                    variant="danger" 
                    onClick={onConfirm}
                >
                    Yes, Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal; 